import { render, staticRenderFns } from "./AdminPib.vue?vue&type=template&id=1af3942a"
import script from "./AdminPib.vue?vue&type=script&lang=js"
export * from "./AdminPib.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports